/**
 * VIEW FEED ARTICLES ENTRY POINT
 *
 * The view feed articles page will display all the articles in a feed
 *
 * @version 0.1
 */

import React from 'react';
import PreviewArticle from './../../reusable/PreviewArticle/PreviewArticle.index';
import ArticleNavigationBox from './../../reusable/ArticleNavigationBox/ArticleNavigationBox';
import DeliveryIcons from './../../reusable/DeliveryIcons/DeliveryIcons.jsx';
import { Link, withRouter } from 'react-router';
import { FormattedMessage } from 'react-intl';
import api from './ViewArticle.api';
import createNewEntityActions from './../../pages/CreateNewEntity/CreateNewEntity.actions';
import xhr from './../../utils/xhr';
import utils from './../../utils/utilities';
import { findIndex } from 'lodash';

class ViewArticleWithNavigation extends React.Component {

    constructor(props) {
        super(props);

        this.state = {};
        this.state.articleData = null;
        this.state.navigation = true;

        this.moveToArticle = this.moveToArticle.bind(this);
        this.loadArticle = this.loadArticle.bind(this);
    }

     componentWillMount() {
         this.loadArticle(this.props.articleId);
     }

     componentWillUnmount() {
         let previousPath = '/' + decodeURIComponent(this.props.backRoute),
             nextLocation = this.props.router.location.pathname;

         // If the user is returning to the previous page then then the previous page might need to know about that.
         if (previousPath.indexOf(nextLocation) > -1) {
             if(previousPath.indexOf('/create-new-entity') > -1) {
                 createNewEntityActions.setReturnFromArticlePageFlag(true);
             }
         }
     }

    componentWillReceiveProps(nextProps) {
        if ((nextProps.articleId !== this.props.articleId) || (nextProps.articleIndex !== this.props.articleIndex)) {
            this.loadArticle(nextProps.articleId);
        }
    }

    moveToArticle(articleId, index) {
        if (this.props.moveToArticle) {
            this.props.moveToArticle(articleId, index);
        } else {
            this.loadArticle(articleId);
        }
    }

    loadArticle(articleId) {
        this.setState({articleData: null, articleId: articleId});
        api.loadSingleArticle(articleId, this.props.injectEntity)
            .then((response)=> {
                if (this.props.injectEntity) {
                    let index = findIndex(response.matchedEntities, {id: this.props.injectEntity});
                    if (index < 0) {
                        response.matchedEntities.push({id: this.props.injectEntity, companyTitle: this.props.title});
                    }
                }
                this.setState({
                    articleData: response
                });
            })
            .catch((error)=>{
                utils.logError(error, "ViewArticleWithNavigation.loadArticle():");
                xhr.handleAllErrors(error);
            });
    }


    render() {
        let articleIndex = parseInt(this.props.articleIndex, 10);
        let articleId = parseInt(this.props.articleId, 10);
        return (
            <div className="view-article-page">
                {this.props.title && !this.props.hideTitle ? <h1 className="notranslate">{this.props.title}</h1> : null}
                <div className="back-navigation no-print">
                    <span className="back-navigation__back-to-results">
                        <span className="la-TriangleLeft"/>
                        <Link to={'/' + decodeURIComponent(this.props.backRoute)}>
                            <FormattedMessage id="Entities_Preview_UIText_previewCompanies.backToResults" />
                        </Link>
                    </span>
                </div>
                {this.state.navigation ?

                    <ArticleNavigationBox
                        fetchUrl={this.props.url}
                        fetchCountUrl={this.props.countUrl}
                        fetchUrlParams={this.props.urlParams}
                        articleId={articleId}
                        articleIndex={articleIndex}
                        articleCount={this.props.articleCount}
                        verb={this.props.verb}
                        embeddedResultList={this.props.embeddedResultList}
                        internalStore={this.props.internalStore}
                        changeArticle={this.moveToArticle}
                    />

                    : null}

                {this.state.articleData?
                    <div>
                        <DeliveryIcons />
                        <PreviewArticle articleData={this.state.articleData} />
                    </div>
                    :
                    <div className="spinner-static-fixed"/>
                }

            </div>
        );

    }

}
export default withRouter(ViewArticleWithNavigation);


// WEBPACK FOOTER //
// ./src/scripts/reusable/PreviewArticle/ViewArticleWithNavigation.jsx